import styled from 'styled-components';

const ImageStyle = styled.div`
	--imagePaddingTop: 50.5%;

	&.imageCont {
		position: relative;
		width: 100%;
		padding-top: var(--imagePaddingTop);
		transition: background-color 0.3s ease-out;

		> span {
			position: absolute;
			top: 0;
			left: 0;
			object-position: center;
			width: 100%;
			height: 100%;
			z-index: 1;
			box-sizing: border-box;
			display: block;
			overflow: hidden;
			background: none;
			opacity: 1;
			border: 0;
			margin: 0;
			padding: 0;
			bottom: 0;
			right: 0;

			transition: opacity 0.8s ease-out;

			.image-placeholder {
				position: absolute;
				inset: 0;
				width: 100%;
				height: 100%;
				background-color: #ecedee;
				transition: opacity 0.3s ease-out;
			}

			img {
				transition: opacity 0.7s ease-out, transform var(--trTime) ease-out;
			}
		}
	}
`;

export default ImageStyle;
